import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import Image from './Image';
/** Wraps Full Image for use with PapiAttachmentFile (e.g.
 *  a deviation's additionalMedia) */ const ImageAttachment = (_param)=>{
    var { attachment, isPublished = false } = _param, props = _object_without_properties(_param, [
        "attachment",
        "isPublished"
    ]);
    var _attachment_caption;
    var _attachment_caption_excerpt;
    return /*#__PURE__*/ React.createElement(Image, _object_spread({
        source: attachment,
        allowFullviewSrcsetForPngs: isPublished,
        altText: (_attachment_caption_excerpt = (_attachment_caption = attachment.caption) === null || _attachment_caption === void 0 ? void 0 : _attachment_caption.excerpt) !== null && _attachment_caption_excerpt !== void 0 ? _attachment_caption_excerpt : attachment.filename
    }, props));
};
ImageAttachment.displayName = 'ImageAttachment';
export default ImageAttachment;

//# sourceMappingURL=ImageAttachment.js.map